import { render, staticRenderFns } from "./AdminShopSettingsNavDrawer.vue?vue&type=template&id=6bf06d49&"
import script from "./AdminShopSettingsNavDrawer.vue?vue&type=script&lang=js&"
export * from "./AdminShopSettingsNavDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports